import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { auth, authApi } from './utils/httpClient';
import { Toaster } from 'react-hot-toast';

const container = document.getElementById('root')!;
const root = createRoot(container);

function AccessDenied() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#f8fafc', fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ textAlign: 'center', padding: '2rem', maxWidth: '420px' }}>
        <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#fee2e2', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.25rem' }}>
          <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="#dc2626" strokeWidth={2}>
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
        </div>
        <h1 style={{ fontSize: '1.375rem', fontWeight: 700, color: '#0f172a', margin: '0 0 0.5rem' }}>Access Denied</h1>
        <p style={{ color: '#64748b', lineHeight: 1.6, margin: '0 0 1.5rem' }}>
          This application is restricted to <strong>Client</strong> users only.
          Your account does not have the required access.
        </p>
        <button
          onClick={() => auth.logout([authApi])}
          style={{ padding: '0.5rem 1.5rem', background: '#1e40af', color: '#fff', border: 'none', borderRadius: '0.5rem', cursor: 'pointer', fontWeight: 600, fontSize: '0.875rem' }}
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}

(async () => {
  await auth.bootstrapAuth([authApi]);

  const profile = JSON.parse(localStorage.getItem('@ind.user') || '{}');
  const hasAccess = profile?.memberships?.some((m: any) => m.ownerType === 'CLIENT');

  root.render(
    <React.StrictMode>
      <Toaster position="top-right" reverseOrder={false} />
      {hasAccess ? <App /> : <AccessDenied />}
    </React.StrictMode>
  );
})();

reportWebVitals();
